import { useContext, useState } from 'react';
import { Role } from 'types';
import { CheckIcon, ChevronsUpDownIcon } from 'lucide-react';
import { cn } from 'utils';
import { Button } from './shadcn/button';
import { Command, CommandGroup, CommandInput, CommandItem, CommandList } from './shadcn/command';
import { Popover, PopoverContent, PopoverTrigger } from './shadcn/popover';
import { useChatbotList } from 'hooks/useChatbotList';
import { AuthContext } from 'contexts';
import { useNavigate, useParams } from 'react-router-dom';

export function SelectBot() {
  const [open, setOpen] = useState(false);
  const { isSuccess, data, isError, isFetching } = useChatbotList();
  const { role } = useContext(AuthContext);

  const navigate = useNavigate();

  const { action, id } = useParams();

  const items = data?.map((e) => ({ value: e.id, label: e.name })) || [];

  if (isFetching) {
    return (
      <Button variant="outline" className="w-[200px] justify-between" disabled>
        Loading...
      </Button>
    );
  }

  if (isError) {
    return <p>Error</p>;
  }

  if (isSuccess && (!items || !items.length)) {
    return (
      <Button variant="outline" className="w-[200px] justify-between" disabled>
        No Chatbots Available
      </Button>
    );
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="w-[200px] justify-between"
        >
          <p className="truncate">
            {id && items.length && items.find((e) => e.value === id)?.label}
          </p>
          <ChevronsUpDownIcon className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[200px] p-0">
        <Command>
          {role == Role.ADMIN && <CommandInput placeholder="Search" />}
          <CommandList>
            <CommandGroup>
              {items.map((e, index) => (
                <CommandItem
                  key={e.value}
                  value={e.label}
                  onSelect={() => {
                    setOpen(false);
                    if (e.value !== id) {
                      const actionPath = action === 'create' ? 'edit' : action;

                      navigate(`/${e.value}/${actionPath}`);
                    }
                  }}
                >
                  <CheckIcon
                    className={cn(
                      'mr-2 h-4 w-4',
                      id === e.value || (!id && index === 0) ? 'opacity-100' : 'opacity-0',
                    )}
                  />
                  <p className="truncate">{e.label}</p>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
        {role == Role.ADMIN && (
          <div className="sticky bottom-0 border-t bg-white p-2">
            <Button
              variant="secondary"
              className="w-full"
              onClick={() => {
                navigate(`/create`);
              }}
            >
              + Create New Bot
            </Button>
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
}
